import type { DateValue } from "react-aria-components";
import {
  DateField as RACDateField,
  type DateFieldProps as RACDateFieldProps,
  DateInput as RACDateInput,
  type DateInputProps as RACDateInputProps,
  DateSegment as RACDateSegment,
  type DateSegmentProps as RACDateSegmentProps,
  Label as RACLabel,
  type LabelProps as RACLabelProps,
} from "react-aria-components";

export interface DateFieldProps<T extends DateValue> extends RACDateFieldProps<T> {}
export interface DateFieldInputProps extends RACDateInputProps {}
export type DateFieldSegmentProps = RACDateSegmentProps;
export interface DateFieldLabelProps extends RACLabelProps {}

export function DateField<T extends DateValue>(props: DateFieldProps<T>) {
  return <RACDateField {...props} />;
}

export function DateFieldInput(props: DateFieldInputProps) {
  return <RACDateInput {...props} />;
}

export function DateFieldSegment(props: DateFieldSegmentProps) {
  return <RACDateSegment {...props} />;
}

export function DateFieldLabel(props: DateFieldLabelProps) {
  return <RACLabel {...props} />;
}
